import { useQuery } from "@tanstack/react-query";
import { toastServerError } from "helpers";
import { ApiError, ApiServiceError } from "libs/api";

import { WhatsAppConversation } from "../../aiConversations.types";
import { AI_CONVERSATIONS_QUERY_KEY } from "../../constants/enums";
import { requestGetConversation } from "./getConversation.request";

/**
 * One conversation by id, for opening a thread that is not in the loaded page
 * of the list (e.g. deep-linked from an order). Disabled without an id.
 */
const useGetConversation = (conversationId?: string | null) => {
  const query = useQuery<WhatsAppConversation, ApiServiceError<ApiError>>({
    queryKey: [AI_CONVERSATIONS_QUERY_KEY, "one", conversationId],
    queryFn: async () => await requestGetConversation(String(conversationId)),
    enabled: Boolean(conversationId),
    onError: toastServerError
  });

  return {
    conversation: query.data,
    // `isLoading` is true for a disabled query too, so callers must pair this
    // with their own "is there an id at all" check.
    isLoading: query.isLoading
  };
};

export default useGetConversation;
